import { XStack, XStackProps, YStack, isWeb } from '@my/ui'
import { GroupPostImage } from 'app/types'
import { Dimensions } from 'react-native'
import { SolitoImage } from 'solito/image'

export interface PostImageProps {
  image?: GroupPostImage
  imagePriority?: boolean
}

/**
 * The image will maintain its aspect ratio and will be centered in the container.
 * If the image is too tall, it will get cropped.
 */
export const PostImage = ({ image, imagePriority, ...props }: PostImageProps & XStackProps) => {
  if (!image || !image.url) {
    return null
  }

  const maxHeight = isWeb ? 500 : Dimensions.get('window').height * 0.5

  return (
    <YStack
      flex={1}
      display={isWeb ? 'block' : 'flex'}
      bg="$overlay3"
      jc="center"
      overflow="hidden"
      {...props}
    >
      <XStack
        flexShrink={1}
        mx="auto"
        maxHeight={maxHeight}
        aspectRatio={image.width / image.height}
      >
        <SolitoImage
          src={image.url}
          alt={image.alt || ''}
          fill
          contentFit="cover"
          sizes="(max-width: 768px) 100vw, 600px"
          priority={imagePriority}
        />
      </XStack>
    </YStack>
  )
}
